import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Workbook from 'react-excel-workbook';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import ActionsCard from '../../../components/common/filter/index';
import reportsContainer from '../../../containers/reports/index';
import Loading from '../../../components/common/loading/index';
import GeneralTableRow from '../../../components/reports/GeneralTableRow';
import {extractAndMatch} from '../../../helpers/specialLimitsByCountry';
import {isCheckToken} from "../../../redux/modules/auth";
import cookieAndLocalStorage from "../../../helpers/cookieAndLocalStorage";

class ReportsPage extends Component {
  constructor(props) {
    super(props);

    this.changeFilter = this.changeFilter.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.fetchRequests = this.fetchRequests.bind(this);
    this.prepareHrReportsDataForExcel = this.prepareHrReportsDataForExcel.bind(this);
    this.toggleHrReport = this.toggleHrReport.bind(this);
    this.toggleManagerReport = this.toggleManagerReport.bind(this);

    this.state = {
      month: 0,
      year: new Date().getFullYear(),
      page: 1,
      requestStatus: 'default',
      reportsData: '',
      isOpenHrReport: false,
      isOpenManagerReport: false,
      userCurrency: props.requestStats && props.requestStats.userCurrency,
      specialLimitsByCountry: props.requestStats && props.requestStats.specialLimitsByCountry,
      uniqueCode:"",
      multiDateReport: {},
      isMultiDate: false,
      updateLanguage: false,
    };

    // Clear report data every page
    props.clearReportState();
  }

  async componentDidMount() {
    const { language,requestStats,isActive,isCheckToken } = this.props;

    this.setState({ updateLanguage: true });
    this.setState({ uniqueCode: requestStats.uniqCode });

    i18next.changeLanguage(language);

    if ( isActive === true ){
      await isCheckToken();
    }
    if(isActive === false){
      cookieAndLocalStorage()
    }
  }

  async componentWillMount(){
    const { isCheckToken,isActive } = this.props;
    if ( isActive === true ){
      await isCheckToken();
    }
    if(isActive === false){
      cookieAndLocalStorage()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.reportsData.length !== nextProps.reportsData.length) {
      this.setState({ reportsData: nextProps.reportsData });
    }
  }

  async onFilterChange(month, year, requestStatus, multiDateReport, isMultiDate) {
    await this.setState({
      month,
      year,
      requestStatus,
      page: 1,
      multiDateReport,
      isMultiDate
    });
    await this.fetchRequests();
  }

  async changeFilter(filter) {
    const {
      month, year, requestStatus, multiDateReport, isMultiDate
    } = filter;

    if (requestStatus !== 'default' && parseInt(month) !== 0 && parseInt(year) > 2000 && this.state.isOpenHrReport) {
      const payload = {
        month,
        year,
        uploaded: requestStatus === 'uploaded' ? 1 : 0,
        isHr: this.props.isHrReport
      };

      await this.props.fetchHrReports(payload);
      this.setState({ reportsData: this.props.reportsData });
    }

    if ((parseInt(month) !== 0 && parseInt(year) > 2000) || isMultiDate) {
      const payload = {
        month,
        year,
        multiDateReport,
        isMultiDate
      };

      if (this.props.isManagerReport && this.state.isOpenManagerReport) {
        const reportPermissionUnitIds = this.props.reportPermissionUnitIds;
        const managerPayload = {
          month,
          year,
          reportPermissionUnitIds,
          multiDateReport,
          isMultiDate
        };

        await this.props.fetchManagerReports(managerPayload);
        this.setState({ reportsData: this.props.reportsData });
      }

      if (this.props.isEmployee) {
        await this.props.fetchEmployeeReports(payload);
        this.setState({ reportsData: this.props.reportsData });
      }
    }
  }

  async fetchRequests() {
    const {
      month, year, requestStatus, page, multiDateReport, isMultiDate
    } = this.state;


    const filter = {
      month,
      year,
      requestStatus,
      page,
      multiDateReport,
      isMultiDate
    };

    await this.changeFilter(filter);
  }

  prepareHrReportsDataForExcel(reportsData) {
    if (reportsData.length > 0) {
      const data = reportsData.map(data => ({
        employeeId: `${data.employeeId}`,
        employmentId: `${data.employmentId}`,
        employeeName: data.employeeName,
        travelExpenseGroup: data.travelExpenseGroup,
        uploadedDate: data.uploadedDate,
        domesticAmount: `${data.calculatedAmount.domestic} TL`,
        domesticTravelTime: `${parseFloat(data.calculatedTravelTime.domestic).toFixed(2)} saat`,
        abroadAmount: `${data.calculatedAmount.abroad} TL`,
        abroadCurrencyAmount: `${data.calculatedAmount.abroadCurrencyAmount}`,
        abroadTravelTime: `${data.calculatedTravelTime.abroad} saat`,
        domesticIndividualAccommodationAmount: `${data.calculatedIndividualAccommodationAmount
        && data.calculatedIndividualAccommodationAmount.domestic} TL`,
        abroadIndividualAccommodationAmount: `${data.calculatedIndividualAccommodationAmount
        && data.calculatedIndividualAccommodationAmount.abroad} TL`,
        abroadIndividualAccommodationCurrencyAmount: `${data.calculatedIndividualAccommodationAmount
        && data.calculatedIndividualAccommodationAmount.abroadCurrencyAmount}`,
        uploaded: data.uploaded === 1 ? 'Aktarıldı' : 'Aktarılmadı',
        country: data.countryAndExchangeRate.country,
        exchangeRate: data.countryAndExchangeRate.exchangeRate
      }));

      return data;
    }

    return [];
  }

  prepareDetailReportsDataForExcel(reportsData) {
    if (reportsData.length > 0) {
      const data = reportsData.map(data => {
        const newLimit = extractAndMatch(data.specialLimitsByCountry, data.abroadTravelCountry);
        const travelExpenseLimit = newLimit || data.travelExpenseLimit;

        let tarId = "";
        if (this.state.uniqueCode === "true"){
          const idStr=data.id;
          tarId = "TAR"+idStr.slice(-8)
        }

        return {
          employeeId: data.employeeId,
          employmentId: data.employmentId,
          employeeName: data.employeeName,
          managerName: data.managerName,
          travelExpenseGroup: data.travelExpenseGroup,
          approvalStatus: data.approvalStatus,
          confirmationDate: data.confirmationDate,
          travelExpenseLimit,
          travelExpenseType: data.travelExpenseType,
          domesticTravelCity: data.domesticTravelCity,
          abroadTravelCountry: data.abroadTravelCountry,
          abroadTravelCity: data.abroadTravelCity,
          abroadRoadFriends: data.abroadRoadFriends,
          travelReasons: data.travelReasons,
          abroadPassportNo: data.abroadPassportNo,
          abroadVisa: data.abroadVisa,
          isGrubuCZ: data.isGrubuCZ,
          createdDate: data.createdDate,
          travelStartDate: data.travelStartDate,
          travelEndDate: data.travelEndDate,
          travelStartHour: data.travelStartHour,
          travelEndHour: data.travelEndHour,
          workStartDate: data.workStartDate,
          workStartHour: data.workStartHour,
          calculatedAmountCurrency: data.calculatedAmountCurrency,
          travelExpenseTime: data.travelExpenseTime,
          travelExpenseTotalDayHour: data.travelExpenseTotalDayHour,
          totalDayHour: data.totalDayHour,
          fractionHour: data.fractionHour,
          fullTime: data.fullTime,
          fractionTime: data.fractionTime,
          calculatedAmount: data.calculatedAmount,
          calculatedCurrencyAmount: data.calculatedCurrencyAmount,
          hasIndividualAccommodation: data.hasIndividualAccommodation,
          hasIndividualAccommodationDay: data.hasIndividualAccommodationDay,
          individualAccommodationAmount: data.individualAccommodationAmount,
          individualAccommodationCurrencyAmount: data.individualAccommodationCurrencyAmount,
          exchangeRate: data.exchangeRate,
          description: data.description,
          uploadedMonth: data.uploadedMonth,
          uploadedYear: data.uploadedYear,
          tarId:tarId,

        };
      });

      return data;
    }

    return [];
  }

  async toggleHrReport() {
    const fullYear = new Date().getFullYear();
    const { isOpenHrReport, isOpenManagerReport } = this.state;

    if (this.state.isOpenManagerReport) {
      await this.setState({ isOpenManagerReport: !isOpenManagerReport });
    }

    await this.setState({
      isOpenHrReport: !isOpenHrReport,
      reportsData: [],
      requestStatus: 'default',
      month: 0,
      year: fullYear
    });
  }

  async toggleManagerReport() {
    const fullYear = new Date().getFullYear();
    const { isOpenManagerReport, isOpenHrReport } = this.state;

    if (this.state.isOpenHrReport) {
      await this.setState({ isOpenHrReport: !isOpenHrReport });
    }

    await this.setState({
      isOpenManagerReport: !isOpenManagerReport,
      reportsData: [],
      requestStatus: 'default',
      month: 0,
      year: fullYear
    });
  }

  isUniqCode(){
    let columns= []
    let uniqueCode = this.state.uniqueCode
    if (uniqueCode === 'true'){
      columns.push(<Workbook.Column label={this.props.t("travelNumber")} value={"tarId"}/>)
    }
    return columns
  }


  render() {
    const { t } = this.props;

    return (

        <div>
          <div className="card">
            <div className="header" style={{ flexDirection: 'column' }}>
              {this.props.isHrReport
                  ? (
                      <button
                          className="btn btn-xs btn-default"
                          onClick={this.toggleHrReport}
                          style={{
                            borderWidth: 1,
                            marginBottom: '10px',
                            width: '35%'
                          }}
                      >
                        {t('payrollTransferReport')}
                        {' '}
                        <i className={`fa ${this.state.isOpenHrReport ? 'fa-angle-down' : 'fa-angle-right'}`} />
                      </button>
                  )

                  : null
              }
              <button
                  className="btn btn-xs btn-default"
                  onClick={this.toggleManagerReport}
                  style={{
                    borderWidth: 1,
                    width: '35%'
                  }}
              >
                {t('detailReport')}
                {' '}

                <i className={`fa ${this.state.isOpenManagerReport ? 'fa-angle-down' : 'fa-angle-right'}`} />
              </button>
              <div>
                <br />
              </div>
            </div>

          </div>
          {
            this.state.isOpenHrReport
                ? (

                    <div>
                      <ActionsCard
                          filterOptionValue="report"
                          onChange={this.onFilterChange}
                          filterValue={{ ...this.state }}
                          showStatus={this.props.isHrReport}
                          isReport
                      />
                      {
                        this.state.reportsData && this.state.reportsData.length > 0
                            ? (
                                <div className="col-md-14">
                                  <div className="card">
                                    <div className="header" style={{ display: 'flow-root' }}>
                                      <h4 className="title">
                                        {
                                          this.state.requestStatus === 'unuploaded'
                                              ? (
                                                  <div
                                                      className="alert alert-info"
                                                      role="alert"
                                                      style={{
                                                        float: 'left',
                                                        marginBottom: '15px'
                                                      }}
                                                  >
                                                    <i dangerouslySetInnerHTML={{ __html: t('managerApprovelMessage') }} />
                                                  </div>
                                              ) : null
                                        }

                                        <div style={{
                                          float: 'right',
                                          marginBottom: '15px'
                                        }}
                                        >
                                <span style={{
                                  fontSize: '14px',
                                  color: 'green',
                                  marginRight: '10px'
                                }}
                                >
                                  {t('downloadReport')}
                                  <i
                                      className="fa fa-angle-right"
                                  />
                                </span>
                                          <Workbook
                                              filename={t('reportFileName')}
                                              element={(
                                                  <OverlayTrigger
                                                      placement="bottom"
                                                      overlay={(
                                                          <Tooltip id="tooltip">
                                                            {t('export')}
                                                          </Tooltip>
                                                      )}
                                                  >
                                                    <button
                                                        type="button"
                                                        className="btn btn-wd btn-success export-btn"
                                                    >
                                        <span className="btn-label">
                                          <i className="fa fa-file-excel-o" aria-hidden="true" />
                                        </span>
                                                    </button>
                                                  </OverlayTrigger>
                                              )}
                                          >

                                            <Workbook.Sheet
                                                data={this.prepareHrReportsDataForExcel(this.state.reportsData)}
                                                name="Sheet A"
                                            >
                                              <Workbook.Column label={t('employeeId')} value="employeeId" />
                                              <Workbook.Column label={t('employmentId')} value="employmentId" />
                                              <Workbook.Column label={t('nameAndSurname')} value="employeeName" />
                                              <Workbook.Column label={t('travelExpenseGroup')} value="travelExpenseGroup" />
                                              <Workbook.Column label={t('payrollPeriod')} value="uploadedDate" />
                                              <Workbook.Column
                                                  label={t('domesticAllowanceAmount')}
                                                  value="domesticAmount"
                                              />
                                              <Workbook.Column
                                                  label={t('domesticAllowanceTravelTime')}
                                                  value="domesticTravelTime"
                                              />
                                              <Workbook.Column
                                                  label={t('overseasAllowanceAmountTL')}
                                                  value="abroadAmount"
                                              />
                                              {this.state.userCurrency === 'eu'
                                                  ? (
                                                      <Workbook.Column
                                                          label={t('overseasAllowanceAmountEuro')}
                                                          value="abroadCurrencyAmount"
                                                      />
                                                  )
                                                  : (
                                                      <Workbook.Column
                                                          label={t('overseasAllowanceAmountDollar')}
                                                          value="abroadCurrencyAmount"
                                                      />
                                                  )
                                              }

                                              <Workbook.Column
                                                  label={t('overseansAllowanceTravelTime')}
                                                  value="abroadTravelTime"
                                              />
                                              <Workbook.Column
                                                  label={t('domesticIndividualAccommodationAmount')}
                                                  value="domesticIndividualAccommodationAmount"
                                              />
                                              <Workbook.Column
                                                  label={t('overseansIndividualAccommodationAmountTL')}
                                                  value="abroadIndividualAccommodationAmount"
                                              />
                                              {this.state.userCurrency === 'eu'
                                                  ? (
                                                      <Workbook.Column
                                                          label={t('overseansIndividualAccommodationAmountEuro')}
                                                          value="abroadIndividualAccommodationCurrencyAmount"
                                                      />
                                                  )
                                                  : (
                                                      <Workbook.Column
                                                          label={t('overseansIndividualAccommodationAmountDollar')}
                                                          value="abroadIndividualAccommodationCurrencyAmount"
                                                      />
                                                  )
                                              }

                                              <Workbook.Column label={t('status')} value="uploaded" />
                                              <Workbook.Column label={t('country')} value="country" />
                                              <Workbook.Column label={t('currencyInfo')} value="exchangeRate" />
                                            </Workbook.Sheet>

                                          </Workbook>
                                        </div>
                                      </h4>
                                    </div>


                                    <div className="content table-responsive table-full-width">
                                      <Loading loading={this.props.reportsData.loading} rows={5} colSpan={9}>
                                        <div className="requests">
                                          <div className="requests-column">
                                            <div className="row">
                                              <div className="col-md-first" />
                                              <div className="col-md-2">
                                                <h5>
                                                  {t('employmentId')}
                                                </h5>
                                              </div>
                                              <div className="col-md-2">
                                                <h5>
                                                  {t('nameAndSurname')}
                                                </h5>
                                              </div>
                                              <div className="col-md-2">
                                                <h5>
                                                  {t('travelExpenseGroup')}
                                                </h5>
                                              </div>
                                              <div className="col-md-2">
                                                <h5>
                                                  {t('domesticAllowanceAmount')}
                                                </h5>
                                              </div>
                                              <div className="col-md-2">
                                                <h5>
                                                  {t('overseansAllowanceAmount')}
                                                </h5>
                                              </div>
                                              <div className="col-md-last">
                                                <h5>
                                                  {t('status')}
                                                </h5>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="requests-content">
                                            {
                                              this.props.reportsData.map(request => (
                                                  <GeneralTableRow
                                                      travelExpenseGroup={request.travelExpenseGroup}
                                                      uploaded={request.uploaded}
                                                      employmentId={request.employmentId}
                                                      key={request.employmentId + request.uploaded}
                                                      calculatedAmount={request.calculatedAmount}
                                                      employeeName={request.employeeName}
                                                      calculatedTravelTime={request.calculatedTravelTime}
                                                      calculatedIndividualAccommodationAmount={
                                                        request.calculatedIndividualAccommodationAmount}
                                                  />
                                              ))
                                            }
                                          </div>
                                        </div>
                                      </Loading>
                                    </div>


                                  </div>
                                </div>
                            )
                            : null
                      }
                    </div>
                )

                : this.state.isOpenManagerReport
                    ? (
                        <div>
                          <ActionsCard
                              filterOptionValue="report"
                              onChange={this.onFilterChange}
                              filterValue={{ ...this.state }}
                              showStatus={false}
                              showSwitch
                              isReport
                          />
                          {
                            this.state.reportsData && this.state.reportsData.length > 0
                                ? (
                                    <div className="col-md-14">
                                      <div className="card">
                                        <div className="header" style={{ display: 'flow-root' }}>
                                          <h4 className="title">
                                            <div style={{
                                              float: 'right',
                                              marginBottom: '15px'
                                            }}
                                            >
                                <span style={{
                                  fontSize: '14px',
                                  color: 'green',
                                  marginRight: '10px'
                                }}
                                >
                                  {t('downloadReport')}
                                  <i
                                      className="fa fa-angle-right"
                                  />
                                </span>
                                              <Workbook
                                                  filename={t('reportFileName')}
                                                  element={(
                                                      <OverlayTrigger
                                                          placement="bottom"
                                                          overlay={(
                                                              <Tooltip id="tooltip">
                                                                {t('export')}
                                                              </Tooltip>
                                                          )}
                                                      >
                                                        <button
                                                            type="button"
                                                            className="btn btn-wd btn-success export-btn"
                                                        >
                                        <span className="btn-label">
                                          <i className="fa fa-file-excel-o" aria-hidden="true" />
                                        </span>
                                                        </button>
                                                      </OverlayTrigger>
                                                  )}
                                              >

                                                <Workbook.Sheet
                                                    data={this.prepareDetailReportsDataForExcel(this.state.reportsData)}
                                                    name="Sheet A"
                                                >
                                                  {this.isUniqCode()}

                                                  <Workbook.Column label={t('employeeId')} value="employeeId" />
                                                  <Workbook.Column label={t('employmentId')} value="employmentId" />
                                                  <Workbook.Column label={t('nameAndSurname')} value="employeeName" />
                                                  <Workbook.Column label={t('travelExpenseGroup')} value="travelExpenseGroup" />
                                                  <Workbook.Column label={t('manager')} value="managerName" />
                                                  <Workbook.Column
                                                      label={t('approvalStatus')}
                                                      value="approvalStatus"
                                                  />
                                                  <Workbook.Column
                                                      label={t('managerApprovalDate')}
                                                      value="confirmationDate"
                                                  />
                                                  <Workbook.Column
                                                      label={t('travelExpenceLimit')}
                                                      value="travelExpenseLimit"
                                                  />
                                                  <Workbook.Column
                                                      label={t('travelType')}
                                                      value="travelExpenseType"
                                                  />
                                                  <Workbook.Column
                                                      label={t('traveledCityDomestic')}
                                                      value="domesticTravelCity"
                                                  />
                                                  <Workbook.Column
                                                      label={t('countryOfBusinessTravel')}
                                                      value="abroadTravelCountry"
                                                  />
                                                  <Workbook.Column
                                                      label={t('peopleTravelingTogether')}
                                                      value="abroadRoadFriends"
                                                  />
                                                  <Workbook.Column
                                                      label={t('reasonForTravel')}
                                                      value="travelReasons"
                                                  />
                                                  <Workbook.Column
                                                      label={t('passportNo')}
                                                      value="abroadPassportNo"
                                                  />
                                                  <Workbook.Column
                                                      label={t('visaStatus')}
                                                      value="abroadVisa"
                                                  />
                                                  <Workbook.Column
                                                      label={t('businessGroup')}
                                                      value="isGrubuCZ"
                                                  />
                                                  <Workbook.Column
                                                      label={t('transactionDate')}
                                                      value="createdDate"
                                                  />
                                                  <Workbook.Column
                                                      label={t('travelStartDate')}
                                                      value="travelStartDate"
                                                  />
                                                  <Workbook.Column
                                                      label={t('travelEndDate')}
                                                      value="travelEndDate"
                                                  />
                                                  <Workbook.Column
                                                      label={t('travelStartTime')}
                                                      value="travelStartHour"
                                                  />
                                                  <Workbook.Column
                                                      label={t('travelEndTime')}
                                                      value="travelEndHour"
                                                  />
                                                  <Workbook.Column
                                                      label={t('jobStartDate')}
                                                      value="workStartDate"
                                                  />

                                                  <Workbook.Column
                                                      label={t('jobStartTime')}
                                                      value="workStartHour"
                                                  />

                                                  <Workbook.Column
                                                      label={t('travelTime')}
                                                      value="travelExpenseTime"
                                                  />
                                                  <Workbook.Column
                                                      label={t('totalDaysTraveled')}
                                                      value="travelExpenseTotalDayHour"
                                                  />
                                                  <Workbook.Column
                                                      label={t('fullDayHours')}
                                                      value="totalDayHour"
                                                  />

                                                  <Workbook.Column
                                                      label={t('theFractionalHour')}
                                                      value="fractionHour"
                                                  />

                                                  <Workbook.Column
                                                      label={t('fullDayVsHour')}
                                                      value="fullTime"
                                                  />

                                                  <Workbook.Column
                                                      label={t('fractionalEquivalent')}
                                                      value="fractionTime"
                                                  />

                                                  <Workbook.Column
                                                      label={t('travelExpensePaymentGross')}
                                                      value="calculatedAmount"
                                                  />
                                                  <Workbook.Column
                                                      label={t('travelExpencePaymentCurrency')}
                                                      value="calculatedCurrencyAmount"
                                                  />

                                                  <Workbook.Column
                                                      label={t('isThereAccommodation')}
                                                      value="hasIndividualAccommodation"
                                                  />
                                                  <Workbook.Column
                                                      label={t('howManyDaysAccommodation')}
                                                      value="hasIndividualAccommodationDay"
                                                  />

                                                  <Workbook.Column
                                                      label={t('individualAccommodationPaymentNetCurrency')}
                                                      value="individualAccommodationAmount"
                                                  />


                                                  <Workbook.Column
                                                      label={t('individualAccommodationPaymentNetTl')}
                                                      value="individualAccommodationCurrencyAmount"
                                                  />
                                                  <Workbook.Column
                                                      label={t('exchangeRate')}
                                                      value="exchangeRate"
                                                  />
                                                  <Workbook.Column
                                                      label={t('exchangeType')}
                                                      value="calculatedAmountCurrency"
                                                  />
                                                  <Workbook.Column
                                                      label={t('explanation')}
                                                      value="description"
                                                  />
                                                  <Workbook.Column
                                                      label={t('transferMonth')}
                                                      value="uploadedMonth"
                                                  />
                                                  <Workbook.Column
                                                      label={t('transferYear')}
                                                      value="uploadedYear"
                                                  />


                                                </Workbook.Sheet>

                                              </Workbook>
                                            </div>
                                          </h4>
                                        </div>

                                      </div>
                                    </div>
                                )
                                : null
                          }
                        </div>
                    )
                    : null
          }
        </div>
    );
  }
}

export default withNamespaces()(withRouter(connect(...reportsContainer)(ReportsPage)));


// WEBPACK FOOTER //
// ./src/pages/travel-expense/reports/index.js